import { defineStore } from 'pinia'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import MoneyCell from '@/onenetwork/components/datatable/MoneyCell.vue'
import {markRaw} from 'vue'


export enum CommissionStatisticActionTypes {
  FILTERING = 'FILTERING',
  PENDING= "PENDING",
  FETCHING= "FETCHING",
  FETCH_SUCCESS = "FETCH_SUCCESS",
  FETCH_FAILURE = "FETCH_FAILURE",
}

interface CommissionStatisticStore {
  action_type: CommissionStatisticActionTypes,
  action_mess: string,
  widgets: {
    revenueThisMonth: {
      value: number,
      growth: number,
    },
    commissionThisMonth: {
      value: number,
      growth: number,
    },
    commissionCompanyThisMonth: {
      value: number,
      growth: number,
    },
    commissionBrokerThisMonth: {
      value: number,
      growth: number,
    },
    paidCommissionBrokerThisMonth: {
      value: number,
      growth: number,
    }
  },
  filter: Array<{
    key: string,
    type: string,
    label: string,
    placeholder: string,
    value: any,
    options?: Array<{label: string, value: string}>
  }>,
  leaderboard: {
    action_type: CommissionStatisticActionTypes,
    action_mess: string,
    uuid: string,
    data: Object,
    filter: Array<{
      key: string,
      type: string,
      label: string,
      placeholder: string,
      value: any,
      options?: Array<{label: string, value: string}>
    }>,
    pageSize: number,
    page: number,
    tabs: Array<any>,
    tableConfig: any,
    selectedIds: Array<string|number>,
  },
  chart: {
    growthData: any,
    commissionByCategory: any,
  },
  listing: {
    action_type: CommissionStatisticActionTypes,
    action_mess: string,
    uuid: string,
    data: Object,
    filter: Array<{
      key: string,
      type: string,
      label: string,
      placeholder: string,
      value: any,
      options?: Array<{label: string, value: string}>
    }>,
    pageSize: number,
    page: number,
    tabs: Array<any>,
    tableConfig: any,
    selectedIds: Array<string|number>,
  },
}

export const useCommissionStatisticStore = defineStore('statistic.commmission.result', {
  state: (): CommissionStatisticStore => ({
    action_type: CommissionStatisticActionTypes.PENDING,
    action_mess: '',
    widgets: {
      revenueThisMonth: {
        value: 30000000000,
        growth: 10,
      },
      commissionThisMonth: {
        value: 3000000000,
        growth: 10,
      },
      commissionCompanyThisMonth: {
        value: 100000000,
        growth: 10,
      },
      commissionBrokerThisMonth: {
        value: 100000000,
        growth: 5,
      },
      paidCommissionBrokerThisMonth: {
        value: 100000000,
        growth: 5,
      }
    },
    filter: [
      {
        key: 'query-date',
        type: 'date-range',
        label: 'Lọc theo thời gian',
        placeholder: 'Chọn thời gian',
        value: '',
      },
      {
        key: 'keyword',
        type: 'taginput',
        label: 'Lọc theo mã môi giới',
        placeholder: 'Nhập từ khoá',
        value: '',
      },
      {
        key: 'level',
        type: 'select-multiple',
        label: 'Cấp độ môi giới',
        placeholder: 'Chọn loại cấp độ',
        value: '',
        options: [
          { label: 'Tất cả', value: '' },
          { label: 'GD Vùng', value: 'manager' },
          { label: 'Thành viên', value: 'member' },
        ],
      },
      {
        key: 'status',
        type: 'select-multiple',
        label: 'Loại môi giới',
        placeholder: 'Chọn loại môi giới',
        value: '',
        options: [
          { label: 'Tất cả', value: '' },
          { label: 'Cá nhân', value: 'individual' },
          { label: 'Công ty', value: 'company' },
        ],
      },
      {
        key: 'province',
        type: 'region-level-1',
        label: 'Lọc theo tỉnh/thành',
        placeholder: 'Chọn tỉnh/thành',
        value: '',
        options: null,
      },
      {
        key: 'district',
        type: 'region-level-2',
        label: 'Lọc theo quận / huyện',
        placeholder: 'Chọn quận / huyện',
        value: '',
        options: null,
      },
    ],
    leaderboard: {
      action_type: CommissionStatisticActionTypes.FETCH_SUCCESS,
      action_mess: '',
      uuid: '',
      data: {
        list: [],
        totalRecords: 0,
        totalPage: 0
      },
      filter: [],
      pageSize: 20,
      page: 1,
      tabs: [],
      tableConfig: {
        canShowHide: false,
        columns: {
          rank: { label: 'STT', component: markRaw(TextCell), class: '', visible: true, sort: false, config: {} },
          info: { label: 'Môi giới', component: markRaw(TextCell), class: '', visible: true, sort: false, config: {} },
          commission: { label: 'Hoa hồng', component: markRaw(MoneyCell), class: '', visible: true, sort: false, config: {} },
        }
      },
      selectedIds: [],
    },
    chart: {
      growthData: [
        { month: '01/2025', companyCommission: 40000000, brokerCommission: 80000000 },
        { month: '02/2025', companyCommission: 60000000, brokerCommission: 90000000 },
        { month: '03/2025', companyCommission: 50000000, brokerCommission: 85000000 },
        { month: '04/2025', companyCommission: 70000000, brokerCommission: 100000000 },
        { month: '05/2025', companyCommission: 90000000, brokerCommission: 120000000 },
        { month: '06/2025', companyCommission: 80000000, brokerCommission: 115000000 },
        { month: '07/2025', companyCommission: 100000000, brokerCommission: 120000000 },
        { month: '08/2025', companyCommission: 110000000, brokerCommission: 135000000 },
        { month: '09/2025', companyCommission: 85000000, brokerCommission: 115000000 },
        { month: '10/2025', companyCommission: 120000000, brokerCommission: 140000000 },
        { month: '11/2025', companyCommission: 130000000, brokerCommission: 150000000 },
        { month: '12/2025', companyCommission: 140000000, brokerCommission: 160000000 },
      ],
      commissionByCategory: [
        { category: 'Căn hộ', value: 950000000 },
        { category: 'Đất nền', value: 620000000 },
        { category: 'Shophouse', value: 340000000 },
        { category: 'Biệt thự', value: 410000000 },
      ],
    },
    listing: {
      action_type: CommissionStatisticActionTypes.FETCH_SUCCESS,
      action_mess: '',
      uuid: '',
      data: {
        list: [],
        totalRecords: 0,
        totalPage: 0
      },
      filter: [],
      pageSize: 20,
      page: 1,
      tabs: [],
      tableConfig: {
        canShowHide: false,
        columns: {
          rank: { label: 'STT', component: markRaw(TextCell), class: '', visible: true, sort: false, config: {} },
          info: { label: 'Môi giới', component: markRaw(TextCell), class: '', visible: true, sort: false, config: {} },
          commission: { label: 'Hoa hồng', component: markRaw(MoneyCell), class: '', visible: true, sort: false, config: {} },
          paid: { label: 'Đã chi trả', component: markRaw(MoneyCell), class: '', visible: true, sort: false, config: {} },
        }
      },
      selectedIds: [],
    },
  }),
  getters: {},
  actions: {
    setFilter(){

    },
    changePageLeaderBoard(page: number) {
      this.leaderboard.page = page;
    },
    changePageSizeLeaderBoard(size: number) {
      this.leaderboard.pageSize = size;
    },
    fetchSummary(){},
    fetchChartData(){},
    fetchLeaderBoard(){},
    fetchListingData(){},
  }
})
